import TemplateView from '../../../../../TemplateView'
import ProcessingContent from './ProcessingContent'
import TransferCheckContent from './TransferCheckContent'
import {paymentMethod, purchaseStrategyType} from '../../../constants'
import {connect} from '../../../../../redux/utils'
import {
    getContactFirstName,
    getContext,
    getDocumentUrls,
    getHostingZone,
    getPaymentMethod,
    getPurchaseStrategyType,
    isContextChanged,
    isHostingZoneChanged,
    isTransferHostingZoneProcessing
} from '../selectors'
import {getStartDate} from '../../chooser/selectors'
import PurchaseSuccessContent from './PurchaseSuccessContent'
import messageResource from '../../../../../messageResource'
import {DateFormat} from '../../../../../date_format'
import {getDocumentsBaseUrl} from '../../../selectors'

class SuccessContent extends TemplateView {
    constructor() {
        super()

        this.state = {
            purchaseStrategyType: '',
            paymentMethod: '',
            processing: false,
            name: '',
            effectDate: new Date(),
            documentUrls: {
                serviceAgreementUrl: null,
                dataProcessingAgreementUrl: null,
                serviceAgreementExhibitUrl: null,
                invoiceUrl: null,
            },
            documentsBaseUrl: '',
            hostingZone: '',
            isHostingZoneChanged: false,
            context: '',
            isContextChanged: false,
        }

        this.onAnyStatePropertyChanged(['purchaseStrategyType', 'paymentMethod', 'processing'], () => {
            this.$processing.toggle(this.state.processing)
            this.$purchaseSuccess.toggle(
                !this.state.processing && this.state.paymentMethod === paymentMethod.CC || this.state.purchaseStrategyType === purchaseStrategyType.FIRST_FREE)
            this.$transferCheckSuccess.toggle(
                !this.state.processing && this.state.paymentMethod !== paymentMethod.CC && this.state.purchaseStrategyType !== purchaseStrategyType.FIRST_FREE)
        })

        this.onAnyStatePropertyChanged(['hostingZone', 'context'], () => {
            this.processing.setState({
                hostingZone: this.state.hostingZone,
                context: this.state.context,
            })

            this.purchaseSuccess.setState({
                hostingZone: this.state.hostingZone,
                context: this.state.context,
            })
        })

        this.onAnyStatePropertyChanged(['isHostingZoneChanged', 'isContextChanged'], () => {
            this.purchaseSuccess.setState({
                isHostingZoneChanged: this.state.isHostingZoneChanged,
                isContextChanged: this.state.isContextChanged,
            })
        })


        this.onAnyStatePropertyChanged(['name', 'effectDate', 'purchaseStrategyType', 'documentUrls'], () => {
            this.purchaseSuccess.setState(this._getPurchaseSuccessTexts())
        })

        this.onAnyStatePropertyChanged(['documentUrls', 'documentsBaseUrl'], () => {
            this.purchaseSuccess.setState({
                documentsBaseUrl: this.state.documentsBaseUrl,
                documentUrls: this.state.documentUrls,
            })
        })

        this.onStateChanged(() => {
            this.transferCheckSuccess.setState(this.state)
        })
    }

    templateHtml() {
        return '<div class="successContent">' +
               '    <div class="processing"></div>' +
               '    <div class="purchaseSuccess"></div>' +
               '    <div class="transferCheckSuccess"></div>' +
               '</div>'
    }

    afterRender() {
        this.$processing = this.find('.processing')
        this.$purchaseSuccess = this.find('.purchaseSuccess')
        this.$transferCheckSuccess = this.find('.transferCheckSuccess')

        this.processing = new ProcessingContent().init(this.$processing)
        this.purchaseSuccess = new PurchaseSuccessContent().init(this.$purchaseSuccess)
        this.transferCheckSuccess = new TransferCheckContent().init(this.$transferCheckSuccess)
        this.dateFormat = new DateFormat(window.SystemSettings.dateFormat)
    }

    _getPurchaseSuccessTexts() {
        switch (this.state.purchaseStrategyType) {
            case purchaseStrategyType.FIRST_PURCHASE:
                return this._getFirstPurchaseSuccessTexts()
            case purchaseStrategyType.PURCHASE:
                return this._getSubsequentPurchaseSuccessTexts()
            case purchaseStrategyType.FIRST_FREE:
                return this._getFirstFreePurchaseSuccessTexts()
            case purchaseStrategyType.ADD_USERS:
                return this._getAddUsersPurchaseSuccessTexts()
        }
    }

    _getFirstPurchaseSuccessTexts() {
        return {
            titleText: messageResource.getMessage('licenses.purchase.success.purchase_title', [this.state.name]),
            titleNoteText: '',
            effectTitleText: messageResource.getMessage(
                'licenses.purchase.success.purchase_title_effect_date',
                [this.dateFormat.formatDate(this.state.effectDate)]
            ),
            documentsNoteText: messageResource.getMessage('licenses.purchase.success.additional_purchase_title'),
        }
    }

    _getSubsequentPurchaseSuccessTexts() {
        const hasInvoiceOnly = this.state.documentUrls.invoiceUrl && !this.state.documentUrls.serviceAgreementUrl &&
                               !this.state.documentUrls.dataProcessingAgreementUrl && !this.state.documentUrls.serviceAgreementExhibitUrl
        let documentsNoteText
        if (hasInvoiceOnly) {
            documentsNoteText = messageResource.getMessage('licenses.purchase.success.purchase.documents_note.invoice_only')
                                + ' '
                                + messageResource.getMessage('licenses.purchase.success.purchase.documents_note.invoice_only.copy_note')
        } else {
            documentsNoteText = messageResource.getMessage('licenses.purchase.success.additional_purchase_title')
        }
        return {
            titleText: messageResource.getMessage('licenses.purchase.success.purchase_title', [this.state.name]),
            titleNoteText: messageResource.getMessage('licenses.purchase.success.purchase_renewal_title_note'),
            effectTitleText: messageResource.getMessage(
                'licenses.purchase.success.purchase_title_effect_date',
                [this.dateFormat.formatDate(this.state.effectDate)]
            ),
            documentsNoteText: documentsNoteText
        }
    }

    _getFirstFreePurchaseSuccessTexts() {
        return {
            titleText: messageResource.getMessage('licenses.purchase.success.purchase_first_free_title', [this.state.name]),
            titleNoteText:  messageResource.getMessage('licenses.purchase.success.purchase_free_title_note'),
            effectTitleText: messageResource.getMessage(
                'licenses.purchase.success.purchase_free_title_effect_date',
                [this.dateFormat.formatDate(this.state.effectDate)]
            ),
            documentsNoteText: messageResource.getMessage('licenses.purchase.success.additional_purchase_title')
        }
    }

    _getAddUsersPurchaseSuccessTexts() {
        let effectTitleText = ''
        let documentsNoteText = ''
        const hasInvoiceOnly = this.state.documentUrls.invoiceUrl && !this.state.documentUrls.serviceAgreementUrl &&
                               !this.state.documentUrls.dataProcessingAgreementUrl && !this.state.documentUrls.serviceAgreementExhibitUrl
        if (hasInvoiceOnly) {
            effectTitleText = messageResource.getMessage('licenses.purchase.success.purchase.documents_note.invoice_only')
            documentsNoteText = messageResource.getMessage('licenses.purchase.success.purchase.documents_note.invoice_only.copy_note')
        } else {
            effectTitleText = ''
            documentsNoteText = messageResource.getMessage('licenses.purchase.success.additional_purchase_title')
        }
        return {
            titleText: messageResource.getMessage('licenses.purchase.success.purchase_title', [this.state.name]),
            titleNoteText: messageResource.getMessage('licenses.purchase.success.purchase_add_users_title_note'),
            effectTitleText: effectTitleText,
            documentsNoteText: documentsNoteText,
        }
    }
}

export default connect(
    (state) => ({
        purchaseStrategyType: getPurchaseStrategyType(state),
        paymentMethod: getPaymentMethod(state),
        effectDate: getStartDate(state),
        name: getContactFirstName(state),
        hostingZone: getHostingZone(state),
        isHostingZoneChanged: isHostingZoneChanged(state),
        context: getContext(state),
        isContextChanged: isContextChanged(state),
        processing: isTransferHostingZoneProcessing(state),
        documentUrls: getDocumentUrls(state),
        documentsBaseUrl: getDocumentsBaseUrl(state),
    }),
)(SuccessContent)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/successStep/SuccessContent.js